$(function () {
    if (window.UA.isSP === true) {

    } else {

    }
    initSP();

    function initSP() {
        var $headerNav = $("#js-l-header-nav");
        $("#js-l-header-nav-open, #js-l-header-nav-close").on("click", function(e) {
            e.preventDefault();
            $headerNav.fadeToggle();
            $headerNav.addClass("is-open");//追加部分
        });
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./src/pc/js/module/menuToggle.js
 ** module id = 6
 ** module chunks = 0
 **/